import Vue from "vue";
import { MutationTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";
import propertyConstructionTypesStore from "./property-construction-types.store";
import { deepCopy } from "../../../../utils/util";
import { itemStateConstant } from "../../../../common";
import { IPropertyMultModel } from "../../../../models/property";

const constructionMutations: MutationTree<IPropertyEditState> = <MutationTree<IPropertyEditState>>{
	[propertyConstructionTypesStore.Set.DELETE_LIST_OF_ARCHITECTURE]: (state: IPropertyEditState, payload) => {
		let architectures = deepCopy(state.property.Architetures)
		let architecture = architectures.find(item => item.FieldId == payload.FieldId)
		if (architecture.Id == 0)
			state.property.Architetures = architectures.filter(item => item.FieldId != payload.FieldId)
		else
			state.property.Architetures.map(item => {
				if (item.FieldId == payload.FieldId)
					item.ItemState = itemStateConstant.Deleted
				return item
			})
	},

	[propertyConstructionTypesStore.Set.ADD_LIST_OF_ARCHITECTURE]: (state: IPropertyEditState, payload) => {
		state.property.Architetures = payload
	},

	[propertyConstructionTypesStore.Set.UPDATE_LIST_OF_ARCHITECTURE]: (state: IPropertyEditState, payload) => {
		let architectures = deepCopy(state.property.Architetures)
		state.property.Architetures = architectures.map(item => {
			if (item.FieldId == payload.FieldId)
				return payload
			return item
		})
	},

	[propertyConstructionTypesStore.Set.HANDLE_SELECT_LIST_OF_ARCHITECTURE]: (state: IPropertyEditState, payload) => {
		Vue.set(state.property, 'Architetures', payload)
	},

	[propertyConstructionTypesStore.Set.HANDLE_SELECT_LIST_OF_USAGE]: (state: IPropertyEditState, payload: IPropertyMultModel[]) => {
		Vue.set(state.property, 'Usages', payload)
	},

	[propertyConstructionTypesStore.Set.HANDLE_SELECT_LIST_OF_INTERIOR_DECOR]: (state: IPropertyEditState, payload: IPropertyMultModel[]) => {
		Vue.set(state.property, 'InteriorDecors', payload)
	},

	[propertyConstructionTypesStore.Set.HANDLE_SELECT_LIST_OF_EXTERIOR_STATE]: (state: IPropertyEditState, payload: IPropertyMultModel[]) => {
		Vue.set(state.property, 'ExteriorStates', payload)
	}
};

export default constructionMutations;
